<template>
  <div v-loading="exchangeETHLoading">
    <!-- 对数线性显示切换 -->

    <!-- <el-row class="switch">
      <el-col>
         <el-button @click="handelLineSwitch"
         style="margin-left:100px;height:35px;border-radius:6px;"
         >{{ $t(`home.switch`)
          }}<span class="according"> {{ $t(switch3) }}</span></el-button
        >
      </el-col>
    </el-row> -->

    <el-tabs v-model="params.exchange" @tab-click="handelChang" type="card" style="margin-bottom: 10px;" >
      <el-tab-pane  v-for="item in options" :key="item.value" :label="item.value" :name="item.value"></el-tab-pane>    
     </el-tabs>




    <!-- <el-row>
      <el-col style="margin-left: 10px;">
        <el-select v-model="value"   @change="handelChang" clearable :placeholder="$t(`home.abbr`)">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-row> -->

    <el-row>
      <el-col :span="24">
        <div
          id="exchangeETHBox"
          style="width: 100%; min-height: 700px"
        ></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import IndexJs from "./index";
export default {
  mixins: [IndexJs],
};
</script>

<style>
</style>